<template>
  <div class="upload-form-cell">
    <van-field
        :label="label"
        error-message="图片最多上传5张"
        :label-width="labelWidth || 130"
    >
      <template #input>
        <div class="up-wrap">
          <van-uploader class="uploader" name="uploader"
                        v-model="uploader"
                        :after-read="afterRead"
                        :before-delete ="onDelete"
                        :preview-options="{closeable: true}"
                        :max-count="5"
                        :disabled="editor===false"
                        :deletable="editor"/>
        </div>
      </template>
    </van-field>
    <van-field v-model="value" :name="name" v-show="false"/>
  </div>
</template>

<script>
export default {
  name: "uploadFormCell",
  props: ['label', 'name', 'initValue','initIndex','labelWidth', 'editor'],
  data() {
    return {
      uploader: this.initValue,
      list: (this.initIndex==null||this.initIndex==''||this.initIndex==undefined)?[]:JSON.parse(this.initIndex),
      value: this.initIndex,
      index: ''
    }
  },
  watch: {
    initValue(newValue, oldValue) {
      console.log('initValue => newValue ', newValue)
      if (newValue==null||newValue=='') { return }
      // this.uploader = newValue
      this.uploader = newValue
      this.value = JSON.stringify(newValue)
    },
    initIndex(newValue, oldValue) {
      this.index = newValue
    },
    list(newValue, oldValue) {
      console.log('list => newValue ', newValue)
      this.value = JSON.stringify(newValue)
      this.$emit('change', this.value)
    },
    // uploader(newValue, oldValue) {
    //   console.log('uploader => newValue ', newValue)
    //   this.$emit('changeValue', newValue.map(value => { return {url: value.content, isImage: true}}))
    // }
  },
  methods: {
    onDelete(file) {
      console.log('onDelete => file ', file)
      // if (file.name == null) {
      //   return true
      // }
      console.log('before => this.list ', this.list)
      this.list = this.list.filter(value => {
        if (value.url != file.url) {
          return true
        } else {
          return  false
        }
      })
      console.log('onDelete => this.list ', this.list)
      return true
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      this.photoCompress(file)
    },
    photoCompress(e) {
      var that = this;
      var file = e.file; // js 获取文件对象
      if (!file || !window.FileReader) return;
      // this.$dialog.loading.open("图片上传中");
      this.$common.photoCompress(file, function (base64) {
        // console.log(base64)
        that.base64 = base64.split(',')
        // that.upLoadImg(base64, file);
        if (!that.list) {
          that.list = []
        }
        that.list = that.list.concat([{name: file.name, url: base64}])
        let data = that.uploader.map(value => {
          if (value.file!=null) {
            return {
              url: value.content, isImage: true, name: value.file.name
            }
          } else {
            return {
              url: value.url, isImage: true, name: value.name
            }
          }
        })
        that.$emit('changeValue', data)
      });
    },
    upLoadImg(base64,file) {
      let that = this;
      let sendData = new Object();
      sendData.imgBase64 = [base64.split(",")[1]]
      sendData.registerId = localStorage.getItem('registerId')
      that.$common.infoSubmit("/app/market/upload/img", sendData, function (res) {
        that.$dialog.loading.close()
        that.$toast.success("上传成功！")
        if (!that.list) {
          that.list = []
        }
        that.list = that.list.concat([{name: file.name, url: res[0]}])
        let data = that.uploader.map(value => {
          if (value.file!=null) {
            return {
              url: value.content, isImage: true, name: value.file.name
            }
          } else {
            return {
              url: value.url, isImage: true, name: value.name
            }
          }
        })
        that.$emit('changeValue', data)
      }, function () {
        that.$dialog.loading.close();
      });
    }
  }
}
</script>
<style lang="less">
.upload-form-cell {
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }

}
</style>
<style scoped lang="less">
.upload-form-cell {
  .up-wrap {
    //margin-left: auto;
  }
  .uploader {

  }
}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/uploadFormCell.vue